module.exports = __webpack_public_path__ + "static/media/17.b58def7e.jpeg";